import React from 'react';
import { useT } from '@repo/common';

const LoginFormRow = ({
  label,
  value,
  onClickChange,
  showEmailForm,
  showPasswordForm,
}) => {
  const t = useT();
  const isFormOpen = showEmailForm || showPasswordForm;

  const displayValue = () => {
    if (!value) {
      if (label === 'Email') return t('Not Added', '미등록');
      if (label === 'Password') return t('Not created', '미생성');
      return '';
    }
    return value;
  };

  const getButtonText = () => {
    if (label === 'Email') {
      if (showEmailForm) return t('Cancel', '취소');
      return value ? t('Change', '변경') : t('Add', '추가');
    }
    if (label === 'Password') {
      if (showPasswordForm) return t('Cancel', '취소');
      return value ? t('Change', '변경') : t('Create', '생성');
    }
    return '';
  };

  return (
    <div className='flex flex-wrap tabletH::flex-nowrap items-center p-0 w-full'>
      <div className='h-6 tabletH:h-auto order-1 flex-1 md:flex-none md:w-[100px] tabletH:py-0.5 tabletH:pr-2 flex items-center text-text-secondary typo-b12Strong tabletH:typo-b16'>
        {t(label, label === 'Email' ? '이메일' : '비밀번호')}
      </div>

      <div
        className={`order-3 md:order-2 flex-1 min-w-full md:min-w-0 pr-2 flex ${
          value ? 'text-text-primary' : 'text-text-placeholder'
        }`}
      >
        {!isFormOpen && <span>{displayValue()}</span>}
      </div>

      <button
        onClick={onClickChange}
        className='order-2 md:order-3 shrink-0 flex px-1.5 tabletH:py-0.5 tabletH:pl-2 tabletH:pr-0 items-center underline typo-b12Strong tabletH:typo-b14'
      >
        {getButtonText()}
      </button>
    </div>
  );
};

export default LoginFormRow;
